// The hero receipt mirrors the app's order confirmation sheet: the fees really are 0,00.
const ITEMS_TOTAL = 3.5;

const money = (value, language) => {
  const fixed = value.toFixed(2);
  return `${language === 'EN' ? fixed : fixed.replace('.', ',')} ₼`;
};

const Row = ({ label, value, index, isFree }) => (
  <div className={`receipt__row${isFree ? ' receipt__row--free' : ''}`} style={{ '--i': index }}>
    <span className="receipt__label">{label}</span>
    <span className="receipt__dots" aria-hidden="true" />
    <span className="receipt__value">{value}</span>
  </div>
);

const Receipt = ({ text, language }) => (
  <div className="receipt-wrap">
    <div className="receipt">
      <div className="receipt__head">
        <span className="receipt__brand">Foody</span>
        <span className="receipt__meta">№ 0042</span>
      </div>
      <p className="receipt__title">{text.title}</p>
      <Row index={0} label={text.items} value={money(ITEMS_TOTAL, language)} />
      <Row index={1} label={text.delivery} value={money(0, language)} isFree />
      <Row index={2} label={text.service} value={money(0, language)} isFree />
      <div className="receipt__rule" aria-hidden="true" />
      <Row index={3} label={text.total} value={money(ITEMS_TOTAL, language)} />
      <div className="receipt__barcode" aria-hidden="true" />
      <span className="receipt__stamp">{text.stamp}</span>
    </div>
  </div>
);

export default Receipt;
